<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
    </el-row> 

    <el-row>
      <el-col :xs="24" :sm="24" :lg="24">
        <el-button type="mini" @click.prevent="goBack" class="ml-20"><i class="el-icon-d-arrow-left"> 回前頁</i>
        </el-button>
      </el-col>
    </el-row> 

    <el-row>
      <el-col :xs="24" :sm="24" :lg="24" style="padding: 20px 10px 20px 30px;">
        
        <el-tabs v-model="activeName" @tab-click="handleTabClick">
          
          <el-tab-pane label="證書資料" name="certInfo" :lazy="true">
            <CertInfo :showCertImage="false"/>
          </el-tab-pane>


        </el-tabs>
      </el-col>
    </el-row>

    
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import CertInfo from "@/views/courses/maintain/cert";



export default {
  name: "CourseDetail",
  components: {
    Breadcrumb,CertInfo
  },
  data() {
    return {
      cid:0,
      currentTab:'',
      activeName:'certInfo'
    }
  },
  
  methods:{
    goBack(){
      this.$router.push('/myspace/courses')
    },

    handleTabClick(){
      //console.log('handleTabClick:', this.activeName)
    }

  },
  mounted() {
    this.cid = parseInt(this.$route.params.cid)
  }
}
</script>

<style scoped>



</style>
